import React, { useState, useCallback } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Input, Text } from '@shootsta/common-react';
import { getWorkspaceUrl } from '../utils/getShareUrl';

type WorkspaceLinkSectionProps = {
  workspaceAccess?: string;
  shareUrl?: string;
};

function WorkspaceLinkSection({
  workspaceAccess,
  shareUrl
}: WorkspaceLinkSectionProps) {
  const [copied, setCopied] = useState(false);

  const workspaceUrl = getWorkspaceUrl(shareUrl);

  const onCopySuccess = useCallback(() => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, []);

  if (!workspaceAccess || workspaceAccess === 'NONE') {
    return null;
  }

  return (
    <div className="video-share-modal__link-section">
      <Text noMargin highlighted>
        Workspace Link
      </Text>
      <Text noMargin placeholder className="video-share-modal__link-section__subtitle">
        Only workspace members with access can view
      </Text>
      <Input
        defaultValue={workspaceUrl}
        key={workspaceUrl}
        className="video-share-modal__link-section__url"
        disabled
      />
      <div className="video-share-modal__link-section__actions">
        <CopyToClipboard text={workspaceUrl} onCopy={onCopySuccess}>
          <Button
            type="TERTIARY"
            prefix={copied ? 'success' : 'duplicate'}
            tooltipId="copy-workspace-link-btn"
            tooltipLabel={copied ? 'Copied!' : 'Copy link'}
          >
            Copy Link
          </Button>
        </CopyToClipboard>
      </div>
    </div>
  );
}

export default WorkspaceLinkSection;
